<template>
  <v-app>
    <div class="app"
         :class="{
      'app--window': URLParams.type !== 'social',
      'app--page': URLParams.type === 'social',
    }">
      <div class="app__content">
        <v-fade-transition origin="top center">
          <router-view></router-view>
        </v-fade-transition>

        <app-loader></app-loader>
        <vue-snotify></vue-snotify>
      </div>

      <v-fade-transition origin="top center">
        <div v-if="URLParams.type === 'social'" class="app__footer">
          <facebook-footer></facebook-footer>
        </div>
      </v-fade-transition>

    </div>
  </v-app>
</template>

<script>
  import { mapActions, mapGetters, mapMutations } from 'vuex'

  import appLoader from '@/components/loader/index.vue'
  import facebookFooter from '@/components/facebook-footer/index.vue'

  import _ from 'lodash'
  import {CONSTANTS} from '@/config/constants';

  export default {
    name: 'app',
    //---components
    components: {
      facebookFooter,
      appLoader,
    },
    //---data
    data () {
      return {
      }
    },
    //---hooks
    created () {
      this.loaderFlag(true);
      let queryCollection = this.$route.query;

      let params = _.cloneDeep(CONSTANTS.APP_URL_PARAMS);

      for (let key in queryCollection) {
        if (params.hasOwnProperty(key)) {
          switch (key) {
            case 'type':
            case 'affiliateCode':
            case 'firstName':
            case 'lastName':
            case 'phone':
            case 'email':
              params[key] = queryCollection[key];
              break
            default:
              break
          }
        }
      }
      this.setURLParams(params);

      if (!this.URLParams.affiliateCode) {
        this.setMessage(
          {
            title: 'Affiliate code not found',
            text: 'Please, specify affiliate code in url params'
          })
        this.loaderFlag(false);
        this.$router.push({name: 'message'});
      } else {
        let getClient = this.getClient(this.URLParams.affiliateCode)

        let getContent = this.getContent('ptf-property-calculator')

        Promise.all([getClient, getContent]).finally(()=> {
          if (this.client === null) {
            this.setMessage(
                {
                  title: 'Affiliate code is incorrect',
                  text: 'Please, call us:',
                  phone: this.company.phone
                })
            this.$router.push({name: 'message'});
          } else if (!this.client.isActiveSubscriber) {
            this.setMessage(
              {
                title: 'You do not have an active subscription',
                text: 'Please, call us:',
                phone: this.company.phone
              })
            this.$router.push({name: 'message'});
          }
          this.loaderFlag(false);
        })
      }
    },
    computed: {
      ...mapGetters({
        URLParams: 'APP/URLParams',
        client: 'CLIENT/client',
        company: 'APP/company',
      })
    },
    //---methods
    methods: {
      ...mapMutations({
        setURLParams: 'APP/APP_URLPARAMS_SET',
        setMessage: 'APP/APP_MESSAGE_SET',
        loaderFlag: 'APP/APP_LOADER_FLAG_TOGGLE',
      }),
      ...mapActions({
        getContent: 'APP/APP_CONTENT_REQUEST_GET',
        getClient: 'CLIENT/CLIENT_REQUEST_GET',
      }),
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass" src="./assets/sass/main.sass"></style>
